import React from "react";
import "./Slider.css";

const Slider = () => {
  return (
    <div
      id="demo"
      className="carousel slide"
      data-ride="carousel"
      aria-label="Columbiaa Hospital Services Slider - Our Medical Facilities and Services"
      role="region"
      aria-roledescription="carousel"
    >
      <ul className="carousel-indicators" role="tablist" aria-label="Slide navigation indicators">
        <li data-target="#demo" data-slide-to="0" className="active" role="tab" aria-selected="true" aria-label="Go to slide 1"></li>
        <li data-target="#demo" data-slide-to="1" role="tab" aria-selected="false" aria-label="Go to slide 2"></li>
        <li data-target="#demo" data-slide-to="2" role="tab" aria-selected="false" aria-label="Go to slide 3"></li>
        <li data-target="#demo" data-slide-to="3" role="tab" aria-selected="false" aria-label="Go to slide 4"></li>
        <li data-target="#demo" data-slide-to="4" role="tab" aria-selected="false" aria-label="Go to slide 5"></li>
        <li data-target="#demo" data-slide-to="5" role="tab" aria-selected="false" aria-label="Go to slide 6"></li>
        <li data-target="#demo" data-slide-to="6" role="tab" aria-selected="false" aria-label="Go to slide 7"></li>
        <li data-target="#demo" data-slide-to="7" role="tab" aria-selected="false" aria-label="Go to slide 8"></li>
        <li data-target="#demo" data-slide-to="8" role="tab" aria-selected="false" aria-label="Go to slide 9"></li>
        <li data-target="#demo" data-slide-to="9" role="tab" aria-selected="false" aria-label="Go to slide 10"></li>
      </ul>

      <div className="carousel-inner" role="group" aria-label="Columbiaa Hospital Services Slides">
        
        {/* <div
          className="carousel-item active"
          role="group"
          aria-roledescription="slide"
          aria-label="Indian Medical Awards Recognition - Columbiaa Hospital Excellence in Healthcare"
        >
          <img
            src="assets/images/banner/womenswellnessch.png"
            alt="Indian Medical Awards recognition for Columbiaa Hospital - Excellence in healthcare services in Bangalore"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            data-aos="fade-left"
            loading="lazy"
          />
        </div> */}
        <div
          className="carousel-item active"
          role="group"
          aria-roledescription="slide"
          aria-label="Indian Medical Awards Recognition - Columbiaa Hospital Excellence in Healthcare"
        >
          <img
            src="assets/images/banner/slider1.png"
            alt="Indian Medical Awards recognition for Columbiaa Hospital - Excellence in healthcare services in Bangalore"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            data-aos="fade-left"
            loading="lazy"
          />
        </div>
        <div
          className="carousel-item"
          role="group"
          aria-roledescription="slide"
          aria-label="Healthcare Magazine Feature - Columbiaa Hospital in Leading Medical Publications"
        >
          <img
            src="assets/images/banner/healthcaremagazine.png"
            alt="Columbiaa Hospital featured in healthcare magazine - Leading multi-speciality hospital in Kasturi Nagar, Bangalore"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            data-aos="fade-left"
            loading="lazy"
          />
        </div>
        <div
          className="carousel-item"
          role="group"
          aria-roledescription="slide"
          aria-label="Advanced Brain and Spine Care Facilities at Columbiaa Hospital"
        >
          <img
                        src="assets/images/banner/indianmedicalawards.png"
            alt="Advanced brain and spine care facilities at Columbiaa Hospital, Kasturi Nagar, Bangalore - State-of-the-art neurosurgery department"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            data-aos="fade-left"
            loading="lazy"
          />
        </div>
         <div
          className="carousel-item"
          role="group"
          aria-roledescription="slide"
          aria-label="Expert Brain and Spine Care - Dr. H.V. Satish Babu, Top Neurosurgeon in Bangalore"
        >
          <img
            src="assets/images/banner/top10neurosurgeon.jpeg"
            alt="Expert Brain and Spine Care at Columbiaa Hospital - Dr. H.V. Satish Babu ranked among Top 10 Neurosurgeons in India, Kasturi Nagar"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            data-aos="fade-left"
            loading="lazy"
          />
        </div>
        <div 
          className="carousel-item" 
          role="group" 
          aria-roledescription="slide"
          aria-label="Modern Operation Theatre at Columbiaa Hospital - Safe Surgical Procedures"
        >
          <img
            src="assets/images/banner/ot.png"
            alt="Modern operation theatre at Columbiaa Hospital, Kasturi Nagar ensuring safe surgical procedures - Advanced OT facilities"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            data-aos="fade-left"
            loading="lazy"
          />
        </div>
        <div 
          className="carousel-item" 
          role="group" 
          aria-roledescription="slide"
          aria-label="State-of-the-art ICU at Columbiaa Hospital - Critical Care Support"
        >
          <img
            src="assets/images/banner/icu.png"
            alt="State-of-the-art ICU at Columbiaa Hospital, Kasturi Nagar for critical care support - 24/7 intensive care unit"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            data-aos="fade-left"
            loading="lazy"
          />
        </div>
        <div 
          className="carousel-item" 
          role="group" 
          aria-roledescription="slide"
          aria-label="Specialised Dialysis Unit at Columbiaa Hospital - Renal Care Services"
        >
          <img
            src="assets/images/banner/dialysis.png"
            alt="Specialised dialysis unit at Columbiaa Hospital, Kasturi Nagar providing 24/7 renal care services - Advanced kidney treatment"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            data-aos="fade-left"
            loading="lazy"
          />
        </div>
        <div 
          className="carousel-item" 
          role="group" 
          aria-roledescription="slide"
          aria-label="Fully Equipped Diagnostic Laboratory at Columbiaa Hospital - Accurate Testing"
        >
          <img
            src="assets/images/banner/lab.png"
            alt="Fully equipped diagnostic laboratory at Columbiaa Hospital, Kasturi Nagar for accurate testing - Advanced pathology services"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            data-aos="fade-left"
            loading="lazy"
          />
        </div>
        <div 
          className="carousel-item" 
          role="group" 
          aria-roledescription="slide"
          aria-label="24/7 Ambulance Services at Columbiaa Hospital - Emergency Response"
        >
          <img
            src="assets/images/banner/ambulances.png"
            alt="24/7 ambulance services from Columbiaa Hospital, Kasturi Nagar for emergency response - Free patient transport"
            className="d-block w-100"
            style={{ height: "75vh", objectFit: "cover" }}
            loading="lazy"
          />
        </div>
      </div>

      <a
        className="carousel-control-prev"
        href="#demo"
        data-slide="prev"
        aria-label="Previous Slide"
        role="button"
        tabIndex={0}
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="sr-only">Previous slide</span>
      </a>
      <a
        className="carousel-control-next"
        href="#demo"
        data-slide="next"
        aria-label="Next Slide"
        role="button"
        tabIndex={0}
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="sr-only">Next slide</span>
      </a>
    </div>
  );
};

export default Slider;
